<span *ngIf="!isFavorite && !isGlobalUser" class="blueText" (click)="setUnsetFavourite(true)"><i class="far fa-heart"></i></span>
<span *ngIf="isFavorite && !isGlobalUser" class="blueText" (click)="setUnsetFavourite(false)"><i class="fas fa-heart"></i></span>
<span *ngIf="!isFavorite && isGlobalUser" class="blueTextNoClick"><i class="far fa-heart"></i></span>
<span *ngIf="isFavorite && isGlobalUser" class="blueTextNoClick"><i class="fas fa-heart"></i></span>
